import PlanetIcon from './PlanetIcon'

export default PlanetIcon
